import { Component, OnDestroy } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'
import { NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase } from '@ng-bootstrap/ng-bootstrap'

import { BaseComponent, FeatureType, Grid, ModalSize, Right, Role } from '../../shared'
import { ActionToolbarButtonsComponent } from '../../shared/reusable-components/action-toolbar-buttons/action-toolbar-buttons.component'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'
import { RoleComponent } from './role.component'

@Component({
    templateUrl: './roles.component.html',
    standalone: true,
    imports: [
        NgbNav,
        NgbNavItem,
        NgbNavItemRole,
        NgbNavLink,
        NgbNavLinkBase,
        FormsModule,
        ActionToolbarCount,
        ActionToolbarButtonsComponent,
        ActionToolbarSearchComponent,
        WjGridModule,
        AutoSizeDirective,
        WjGridFilterModule,
    ],
})
export class RolesComponent extends BaseComponent implements OnDestroy {
    faSearch = faSearch
    rolesGrid: Grid<Role>
    rightsGrid: Grid<Right>
    reportGrid: Grid<Right>

    active = 1

    constructor() {
        super()
        this.rolesGrid = new Grid<Role>(this.services)
            .setupModalEditing(this.services.data.roles, 'Role', RoleComponent, () => new Role(), this, ModalSize.large)
            .filterBy(item => [item.name])
        this.rolesGrid.canEdit = this.canEdit
        this.rolesGrid.selectionChanged.on(this.updateRightsGrid.bind(this))
        this.rolesGrid.itemEdited.on(this.refresh.bind(this))
        this.rightsGrid = new Grid<Right>(this.services).filterBy(item => [item.name])
        this.reportGrid = new Grid<any>(this.services).filterBy(item => [item.right, item.userNames])
        this.refresh()
    }

    ngOnDestroy() {
        this.rolesGrid.selectionChanged.off(this.updateRightsGrid)
        this.rolesGrid.itemEdited.off(this.refresh.bind(this))
    }

    public refresh() {
        this.cancelableRequest(
            '',
            true,
            this.services.data
                .load(
                    true,
                    true,
                    this.services.data.roles.queryAll(),
                    this.services.data.rights.queryAll(),
                    this.services.data.get('api/Right/GetRightUsers'),
                )
                .subscribe({
                    next: result => {
                        this.initialLoadingComplete()
                        this.rolesGrid.items = result[0]
                        this.reportGrid.items = result[2]
                    },
                }),
        )
    }

    public get canEdit() {
        return this.services.authentication.hasFeature([FeatureType.UsersEdit])
    }

    private updateRightsGrid() {
        if (!this.rolesGrid.selectedItem) return
        const rightsIds = this.rolesGrid.selectedItem.rightsIds
        this.rightsGrid.items = this.services.data.rights.items.filter(x => rightsIds.indexOf(x.id) > -1)
    }
}
